<template>
    <v-tabs :class='classe' icons-and-text>              
        <v-tab key="1" to="/changeData">
            <v-tooltip left>
                <template v-slot:activator="{ on }">    
                        <span class='overline'>Revelação</span>
                        <v-icon v-on="on" left>mdi-gender-male-female</v-icon>
                </template>
                <span> Cadastre e Visualize aqui as informações do seu Chá Revelação </span>
            </v-tooltip> 
        </v-tab>
        <v-tab key="2" to="/ListaPresentes">
            <v-tooltip left>
                <template v-slot:activator="{ on }">    
                    <span class='overline'>Lista de Presentes</span>
                    <v-icon v-on="on" left>mdi-gift</v-icon>
                </template>
                <span> Informe aqui a lista de presentes para o seu Bebê </span>
            </v-tooltip> 
        </v-tab>
        <v-tabs-items>            
            <router-view name='home'></router-view>
        </v-tabs-items>             
    </v-tabs>
</template>
<script>
import $ from 'jquery'

export default {
    data: () => ({
        classe: 'v-tabs--vertical'
    }),
    created(){
        this.$router.replace('/changeData')
        let teste = $(window).width();
        if (teste <= 380) 
            this.classe = 'v-tabs--fixed-tabs'
        else 
            this.classe = 'v-tabs--vertical'

        // console.log("testes", teste)
        //class='v-tabs--vertical' 
        //class='v-tabs--fixed-tabs'
    }
}
</script>
<style scoped>
@media (max-width: 380px) {

}
</style>

